// Copyright The OpenTelemetry Authors
// SPDX-License-Identifier: Apache-2.0

import styled from 'styled-components';

export const Recommendations = styled.section`
  max-width: 1240px;
  margin: 24px auto 48px;
  padding: 0 20px;

  ${({ theme }) => theme.breakpoints.desktop} {
    padding: 0 32px;
  }
`;

export const ProductList = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: 24px;

  ${({ theme }) => theme.breakpoints.desktop} {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(230px, 1fr));
  }
`;

export const TitleContainer = styled.div`
  border-top: 1px solid ${({ theme }) => theme.colors.border};
  padding: 40px 0 24px;
  width: 100%;
`;

export const Title = styled.h3`
  margin: 0;
  font-size: ${({ theme }) => theme.sizes.mLarge};
  font-weight: ${({ theme }) => theme.fonts.semiBold};
  letter-spacing: -0.02em;
  color: ${({ theme }) => theme.colors.ink};

  ${({ theme }) => theme.breakpoints.desktop} {
    font-size: 28px;
  }
`;
